import Vue from 'vue';

export class Tecnicos {

    static async combo (){
        return Vue.http.get('v1/tecnicos/combo');
    }

    static async exist (){
        let response = await Vue.http.get('v1/tecnicos/total');
        return response.data.count > 0;
    }

}
